import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { FaChartBar, FaChartLine, FaChartPie } from "react-icons/fa";
import { useTheme } from "../../../Themecontext/Themecontext";

const Demo = ({ data = [] }) => {
    // ================= MOBILE =================



    const { Colourdata } = useSelector((state) => state.ClientLogin);

    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");

    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "GRAYDARKNEW",
    );

    const { theme } = useTheme();
    const isdark = theme;

    const [isMobile, setIsMobile] = useState(window.innerWidth < 576);


    const getLabelInterval = () => {
        const totalLabels = chartLabels?.length || 0;

        // desktop pe sab dikhao
        if (!isMobile) return 0;

        // mobile responsive logic
        if (totalLabels > 25) {
            return (index) => index % 3 !== 0; // 1 show, 2 skip
        }

        if (totalLabels > 12) {
            return (index) => index % 2 !== 0; // alternate
        }

        return 0; // sab show
    };


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 576);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    const formatToTwoDecimal = (val) => {
        const num = Number(val);

        if (isNaN(num)) return "0.00";

        return num.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    // ================= CHART TYPE =================
    const [chartType, setChartType] = useState("bar");

    // ================= DATA =================
    const hiddenColumns = [
        "inwMeter",
        "inwOpMeter",
        "TotalOut",
        "NewBal",
        "Shortage",
        "FinMtr",
        "TotalOpInwMeter",
        "FinishMeter",
        "BalMeter",
        "TotalInwMeter",
    ];

    const filteredChartData =
        data?.filter((item) => {
            const columnName = item?.month;

            return !hiddenColumns.includes(columnName);
        }) || [];

    const chartLabels = filteredChartData?.map(
        (item) =>
            item?.month === null ||
                item?.month === undefined ||
                item?.month === ""
                ? "N/A"
                : String(item?.month)
    );

    const chartValues = filteredChartData?.map((item) => {
        const num = Number(item?.value || 0);

        return isNaN(num) ? 0 : num;
    });


    const gradientColor =
        isdark === "light"
            ? iscolour?.Colour1
            : iscolourDark?.Colour1;

    // ================= LINE OPTION =================
    const lineOption = {
        tooltip: {
            trigger: "axis",
            confine: true,
            formatter: function (params) {
                const data = params[0];

                return `
            <div>
                <strong>${data.axisValue}</strong><br/>
                Value: ${formatToTwoDecimal(data.value)}
            </div>
        `;
            },
        },

        grid: {
            left: "5%",
            right: "5%",
            top: "15%",
            bottom: isMobile ? "30%" : "12%",
            containLabel: true,
        },

        xAxis: {
            type: "category",
            boundaryGap: false,
            data: chartLabels,

            axisLabel: {
                interval: isMobile && chartLabels?.length > 20 ? 1 : 0,
                color: isdark === "light" ? "#000" : "#fff",
                rotate: isMobile ? 60 : 45,
                fontSize: isMobile ? 9 : 12,
                margin: 14,
                hideOverlap: true,

                formatter: (value) => {
                    if (!value) return "N/A";

                    return String(value).length > 10
                        ? String(value).slice(0, 10) + "..."
                        : value;
                },
            },
        },

        yAxis: {
            type: "value",

            axisLabel: {
                fontSize: isMobile ? 10 : 12,
                color: isdark === "light" ? "#000" : "#fff",
            },

            splitLine: {
                show: true,

                lineStyle: {
                    color:
                        isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
                    type: "solid",
                    width: 1,
                },
            },
        },

        series: [
            {
                name: "India",
                type: "line",
                smooth: true,
                data: chartValues,

                lineStyle: {
                    width: isMobile ? 2 : 4,
                    color:
                        isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                },

                itemStyle: {
                    color:
                        isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                },


                areaStyle: {
                    color: {
                        type: "linear",

                        x: 0,
                        y: 0,

                        x2: 0,
                        y2: 1,

                        colorStops: [
                            {
                                offset: 0,
                                color: gradientColor + "CC", // 80% opacity
                            },

                            {
                                offset: 0.5,
                                color: gradientColor + "66", // 40% opacity
                            },

                            {
                                offset: 1,
                                color: gradientColor + "05", // almost transparent
                            },
                        ],
                    },
                },
            },
        ],
    };

    const barOption = {
        tooltip: {
            trigger: "axis",
            confine: true,

            textStyle: {
                fontSize: isMobile ? 10 : 12,
            },

            padding: isMobile ? 6 : 10,

            formatter: function (params) {
                const data = params[0];

                return `
            <div>
                <strong>${data.axisValue}</strong><br/>
                Value: ${formatToTwoDecimal(data.value)}
            </div>
        `;
            },
        },

        grid: {
            left: "5%",
            right: "5%",
            top: "15%",
            bottom: isMobile ? "30%" : "12%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: chartLabels || [],

            boundaryGap: true,

            axisTick: {
                alignWithLabel: true,
            },

            splitLine: {
                show: false,
            },

            axisLabel: {
                interval: getLabelInterval(), // same as line chart
                color: isdark === "light" ? "#000" : "#fff",

                rotate: isMobile ? 60 : 45,
                fontSize: isMobile ? 9 : 12,
                margin: 14,

                hideOverlap: true,
                overflow: "truncate",
                width: isMobile ? 50 : 80,

                formatter: (value) => {
                    if (!value) return "N/A";

                    return String(value).length > 10
                        ? String(value).slice(0, 10) + "..."
                        : value;
                },
            },
        },

        yAxis: {
            type: "value",

            axisLabel: {
                fontSize: isMobile ? 10 : 12,
                color: isdark === "light" ? "#000" : "#fff",
            },

            splitLine: {
                show: true,
                lineStyle: {
                    color:
                        isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
                    type: "solid",
                    width: 1,
                },
            },
        },

        series: [
            {
                type: "bar",

                data: chartValues || [],

                barWidth: isMobile ? "65%" : "70%",

                itemStyle: {
                    borderRadius: [8, 8, 0, 0],

                    color: {
                        type: "linear",
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,

                        colorStops: [
                            {
                                offset: 0,
                                color:
                                    isdark === "light"
                                        ? iscolour?.Colour1
                                        : iscolourDark?.Colour1,
                            },
                        ],
                    },
                },
            },
        ],
    };
    // ================= PIE OPTION =================
    const pieOption = {
        tooltip: {
            trigger: "item",
            confine: true,

            textStyle: {
                fontSize: isMobile ? 10 : 12,
            },

            padding: isMobile ? 6 : 10,
            borderWidth: 0,

            formatter: function (params) {
                return `
            <div>
                <strong>${params.name}</strong><br/>
                Value: ${formatToTwoDecimal(params.value)}<br/>
                ${params.percent}%
            </div>
        `;
            },
        },

        legend: {
            top: isMobile ? "78%" : "85%",

            itemWidth: isMobile ? 10 : 18,
            itemHeight: isMobile ? 10 : 18,

            textStyle: {
                fontSize: isMobile ? 8 : 12,
                color:
                    isdark === "light"
                        ? "#000"
                        : "#fff",
            },
        },

        series: [
            {
                name: "Share",
                type: "pie",

                top: isMobile ? 10 : 20,
                bottom: isMobile ? 20 : 40,

                radius: isMobile ? ["40%", "60%"] : ["50%", "75%"],

                center: isMobile ? ["50%", "36%"] : ["50%", "42%"],

                avoidLabelOverlap: true,

                data:
                    data
                        ?.slice(-12) // last 12 records
                        ?.map((item) => ({
                            name: item?.month || "",
                            value: Number(item?.value || 0),
                        })) || [],
                label: {
                    show: !isMobile,
                    position: "outside",
                    formatter: "{b}: {d}%",
                    fontSize: 12,
                    color:
                        isdark === "light"
                            ? "#000"
                            : "#fff",
                },

                labelLine: {
                    show: !isMobile,
                    length: isMobile ? 8 : 15,
                    length2: isMobile ? 5 : 10,

                    lineStyle: {
                        width: 2,

                        color:
                            isdark === "light"
                                ? "#000"
                                : "#fff",
                    },
                },

                color: [
                    isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,

                    isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,

                    isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

                    isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour4,

                    isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour5,

                    isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour6,

                    isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7,

                    isdark === "light" ? iscolour?.Colour8 : iscolourDark?.Colour8,

                    isdark === "light" ? iscolour?.Colour9 : iscolourDark?.Colour9,

                    isdark === "light" ? iscolour?.Colour10 : iscolourDark?.Colour10,

                    isdark === "light" ? iscolour?.Colour13 : iscolourDark?.Colour13,

                    isdark === "light" ? iscolour?.Colour14 : iscolourDark?.Colour14,
                ],

                itemStyle: {
                    borderColor: "#fff",
                    borderWidth: 2,
                    borderRadius: 8,
                },

                emphasis: {
                    scale: true,

                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: "rgba(14, 14, 14, 0.25)",
                    },
                },
            },
        ],
    };

    // ================= GET OPTION =================
    const getOption = () => {
        switch (chartType) {
            case "line":
                return lineOption;

            case "pie":
                return pieOption;

            case "bar":
                return barOption;

            default:
                return barOption;
        }
    };

    return (
        <div
            style={{
                width: "100%",
                background:
                    isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour7,
                // borderRadius: "16px",
                padding: isMobile ? "10px" : "20px",
            }}
        >
            {/* BUTTONS */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    flexWrap: "wrap",
                }}
            >
                <button
                    onClick={() => setChartType("bar")}
                    title="Bar Chart"
                    style={{
                        width: isMobile ? "30px" : "40px",
                        height: isMobile ? "30px" : "40px",
                        border: "none",
                        borderRadius: "12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "0.3s",
                        backgroundColor:
                            chartType === "bar"
                                ? isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour5
                                : "transparent",

                        color:
                            chartType === "bar"
                                ? isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour6
                                : isdark === "light"
                                    ? iscolour?.Colour3
                                    : iscolourDark?.Colour4,

                        border: `2px solid ${chartType === "bar"
                            ? isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour5
                            : isdark === "light"
                                ? iscolour?.Colour4
                                : iscolourDark?.Colour5
                            }`,
                    }}
                >
                    <FaChartBar size={isMobile ? 16 : 20} />
                </button>

                <button
                    onClick={() => setChartType("line")}
                    title="Line Chart"
                    style={{
                        width: isMobile ? "30px" : "40px",
                        height: isMobile ? "30px" : "40px",
                        border: "none",
                        borderRadius: "12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "0.3s",
                        backgroundColor:
                            chartType === "line"
                                ? isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour5
                                : "transparent",

                        color:
                            chartType === "line"
                                ? isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour6
                                : isdark === "light"
                                    ? iscolour?.Colour3
                                    : iscolourDark?.Colour4,

                        border: `2px solid ${chartType === "line"
                            ? isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour5
                            : isdark === "light"
                                ? iscolour?.Colour4
                                : iscolourDark?.Colour5
                            }`,
                    }}
                >
                    <FaChartLine size={isMobile ? 16 : 20} />
                </button>

                <button
                    onClick={() => setChartType("pie")}
                    title="Pie Chart"
                    style={{
                        width: isMobile ? "30px" : "40px",
                        height: isMobile ? "30px" : "40px",
                        border: "none",
                        borderRadius: "12px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "0.3s",
                        backgroundColor:
                            chartType === "pie"
                                ? isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour5
                                : "transparent",

                        color:
                            chartType === "pie"
                                ? isdark === "light"
                                    ? iscolour?.Colour5
                                    : iscolourDark?.Colour6
                                : isdark === "light"
                                    ? iscolour?.Colour3
                                    : iscolourDark?.Colour4,

                        border: `2px solid ${chartType === "pie"
                            ? isdark === "light"
                                ? iscolour?.Colour1
                                : iscolourDark?.Colour5
                            : isdark === "light"
                                ? iscolour?.Colour4
                                : iscolourDark?.Colour5
                            }`,
                    }}
                >
                    <FaChartPie size={isMobile ? 16 : 20} />
                </button>
            </div>

            {/* CHART */}
            <div
                style={{
                    width: "100%",
                    height: isMobile ? "350px" : "400px",
                }}
            >
                <ReactECharts
                    key={chartType}
                    option={getOption()}
                    notMerge={true}
                    lazyUpdate={true}
                    autoResize={true}
                    opts={{
                        renderer: "canvas",
                    }}
                    style={{
                        width: "100%",
                        height: "100%",
                    }}
                />
            </div>
        </div >
    );
};

export default Demo;
